import { render } from "./ForumMainNavigation.vue?vue&type=template&id=8515fca6&scoped=true"
import script from "./ForumMainNavigation.vue?vue&type=script&lang=js"
export * from "./ForumMainNavigation.vue?vue&type=script&lang=js"

import "./ForumMainNavigation.vue?vue&type=style&index=0&id=8515fca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8515fca6"]])

export default __exports__